import { convertISODateToHumanReadableDate } from '@sonar-software/sonar-ts-lib';
import { Import } from '@sonar-software/sonar-imports';
import React from 'react';
import { SyncLogs } from '../sync/SyncLog';
import { useLatestSalesforceSync } from '@hooks';

import { COPY_GENERIC, COPY_SPECIFIC, ImportStatus } from '@sonar-software/sonar-ts-constants';

function renderStatus(sync: Import, result: string) {
	const { finishedOn, startedOn } = sync;
	const formattedFinishedOnString = convertISODateToHumanReadableDate(finishedOn);
	const formattedStartedOnString = convertISODateToHumanReadableDate(startedOn);

	return (
		<div className='status'>
			<span className='h2'>{ COPY_SPECIFIC.SUMMARY }</span>
			<div className='started-on'>{ COPY_GENERIC.IMPORT_STARTED_ON(formattedStartedOnString) }</div>
			<div className='finished-on'>{ COPY_GENERIC.IMPORT_FINISHED_ON(formattedFinishedOnString) }</div>
			{ result }
		</div>
	);
}

export const LastSyncStatus: React.FC = () => {
	const latestSync = useLatestSalesforceSync();

	if (!latestSync) {
		return null;
	}

	switch (latestSync.status) {
	case ImportStatus.Completed:
		return renderStatus(latestSync, COPY_GENERIC.IMPORT_SUCCESS);
	case ImportStatus.Failed:
		return renderStatus(latestSync, COPY_GENERIC.IMPORT_FAILURE);
	default:
		return (
			<div>
				<span>{ COPY_GENERIC.SYNC_IN_PROGRESS }</span>
				<SyncLogs logs={ latestSync.logs } />
			</div>
		);
	}
};
